import React from "react";
import filter from "../../assests/images/filter.svg";
// import { Accordion, Form } from "react-bootstrap";
export default function FilterMenuResults(props) {
  return (
    <>
      <div className="dropdown">
        <button
          className="btn form-label filter-box"
          type="button"
          id="filter"
          data-bs-toggle="dropdown"
          data-bs-auto-close="outside"
          aria-expanded="false"
        >
          <img src={filter} alt="" />
          <span style={{ paddingLeft: "8px" }}>Filter</span>
        </button>
        <ul
          className="dropdown-menu p-3"
          aria-labelledby="filter"
          id="AppDropDownId"
          style={{ minWidth: "13rem" }}
        >
          <li className="sub-step-link">Add Filters</li>
          <li>
            <div className="accordion" id="filterRunType">
              <div className="border-0" style={{ padding: "16px 0 0px 0" }}>
                <span>
                  <button
                    className="accordion-button collapsed no-focus-outline"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseRunType"
                    aria-expanded="false"
                    aria-controls="collapseRunType"
                    style={{ padding: "0 0 10px 0" }}
                  >
                    <span
                      className="review-text menu-options"
                      style={{ padding: "0" }}
                    >
                      Run Type
                    </span>
                  </button>
                </span>
                <div
                  id="collapseRunType"
                  className="accordion-collapse collapse"
                  data-bs-parent="#filterRunType"
                >
                  <div className="pb-0 px-2">
                    <div className="form-check mb-1">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="runType"
                        id="iSort Fractions"
                        value="iSort Fractions"
                        onChange={()=>{}}
                        checked={props.filters.runType === "iSort Fractions"}
                        onClick={(e) =>
                          props.handleFilterChange("runType", e.target.value)
                        }
                      />
                      <label className="form-check-label sub-text">
                        iSort Fractions
                      </label>
                    </div>
                    <div className="form-check pb-0 mb-0">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="runType"
                        id="iSort HiRes"
                        value="iSort HiRes"
                        onChange={()=>{}}
                        checked={props.filters.runType === "iSort HiRes"}
                        onClick={(e) =>
                          props.handleFilterChange("runType", e.target.value)
                        }
                      />
                      <label className="form-check-label sub-text">
                        iSort HiRes
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div className="accordion" id="filterUpload">
              <div className="border-0" style={{ padding: "10px 0 0 0" }}>
                <span>
                  <button
                    className="accordion-button collapsed no-focus-outline"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseUpload"
                    aria-expanded="false"
                    aria-controls="collapseUpload"
                    style={{ padding: "0px 0 10px 0" }}
                  >
                    <span
                      className="review-text menu-options"
                      style={{ padding: "0" }}
                    >
                      Date
                    </span>
                  </button>
                </span>
                <div
                  id="collapseUpload"
                  className="accordion-collapse collapse sub-text px-2"
                  data-bs-parent="#filterUpload"
                >
                  <div>
                    <label>Start Date</label>
                    <input
                      className="form-control"
                      type="date"
                      name="startDate"
                      max={new Date().toISOString().split("T")[0]}
                      onChange={(e) =>
                        props.handleFilterChange("startDate", e.target.value)
                      }
                    />
                  </div>
                  <div>
                    <label>End Date</label>
                    <input
                      className="form-control"
                      type="date"
                      name="endDate"
                      min={props.filters.startDate || null} // Cannot be before start date
                      max={new Date().toISOString().split("T")[0]}
                      onChange={(e) =>
                        props.handleFilterChange("endDate", e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div className="accordion" id="parameterAccordion">
              <div className=" border-0" style={{ padding: "10px 0 0 0" }}>
                <button
                  className="accordion-button collapsed  no-focus-outline"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#parametersCollapse"
                  aria-expanded="false"
                  aria-controls="parametersCollapse"
                  style={{ padding: "0 0 10px 0" }}
                >
                  <span
                    className="review-text menu-options"
                    style={{ padding: "0" }}
                  >
                    Parameters
                  </span>
                </button>
                <div
                  id="parametersCollapse"
                  className="accordion-collapse collapse"
                  data-bs-parent="#parameterAccordion"
                >
                  <div className="accordion-body p-0 px-3">
                    {/* Mode Section */}
                    <div className="accordion" id="modeAccordion">
                      <div className="border-0">
                        <button
                          className="accordion-button collapsed p-0 no-focus-outline"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#modeCollapse"
                          aria-expanded="false"
                          aria-controls="modeCollapse"
                          style={{ padding: "0 0 10px 0" }}
                        >
                          <span
                            className="review-text menu-options"
                            style={{ padding: "0" }}
                          >
                            Mode
                          </span>
                        </button>
                        <div
                          id="modeCollapse"
                          className="accordion-collapse collapse"
                          data-bs-parent="#modeAccordion"
                        >
                          <div className="accordion-body p-0 px-3">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="mode"
                                id="blood"
                                value="blood"
                                onChange={()=>{}}
                                checked={props.filters.mode === "blood"}
                                onClick={(e) =>
                                  props.handleFilterChange(
                                    "mode",
                                    e.target.value
                                  )
                                }
                              />
                              <label
                                className="form-check-label sub-text"
                                htmlFor="blood"
                              >
                                Blood
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="mode"
                                id="tissue"
                                value="tissue"
                                onChange={()=>{}}
                                checked={props.filters.mode === "tissue"}
                                onClick={(e) =>
                                  props.handleFilterChange(
                                    "mode",
                                    e.target.value
                                  )
                                }
                              />
                              <label
                                className="form-check-label sub-text"
                                htmlFor="tissue"
                              >
                                Tissue
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Quantile Normalisation Section */}
                    <div className="accordion" id="normalisationAccordion">
                      <div
                        className="border-0"
                        style={{ padding: "10px 0 0 0" }}
                      >
                        <button
                          className="accordion-button collapsed p-0 no-focus-outline"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#normalisationCollapse"
                          aria-expanded="false"
                          aria-controls="normalisationCollapse"
                          style={{ padding: "0 0 10px 0" }}
                        >
                          <span
                            className="review-text menu-options"
                            style={{ padding: "0" }}
                          >
                            Quantile Normalisation
                          </span>
                        </button>
                        <div
                          id="normalisationCollapse"
                          className="accordion-collapse collapse"
                          data-bs-parent="#normalisationAccordion"
                        >
                          <div className="accordion-body p-0 px-3">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="normalisation"
                                id="enabled"
                                value="enabled"
                                onChange={()=>{}}
                                checked={
                                  props.filters.normalisation === "enabled"
                                }
                                onClick={(e) =>
                                  props.handleFilterChange(
                                    "normalisation",
                                    e.target.value
                                  )
                                }
                              />
                              <label
                                className="form-check-label sub-text"
                                htmlFor="enabled"
                              >
                                Enabled
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="normalisation"
                                id="disabled"
                                onChange={()=>{}}
                                value="disabled"
                                checked={
                                  props.filters.normalisation === "disabled"
                                }
                                onClick={(e) =>
                                  props.handleFilterChange(
                                    "normalisation",
                                    e.target.value
                                  )
                                }
                              />
                              <label
                                className="form-check-label sub-text"
                                htmlFor="disabled"
                              >
                                Disabled
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}
